













import Vue from 'vue'
import FullModalLayout from '@/components/modal/basics/FullModal/FullModalLayout.vue'
import FullModalHeaderTitle from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderTitle.vue'
import FullModalHeaderCloseButton from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderCloseButton.vue'
import SearchFacilityDetailForm from './basics/SearchFacilityDetailForm.vue'
import { SearchParams } from '@/core/Facilities'

export default Vue.extend({
  name: 'SearchFacilityDetailModal',
  components: {
    FullModalLayout,
    FullModalHeaderTitle,
    FullModalHeaderCloseButton,
    SearchFacilityDetailForm,
  },
  props: {
    name: {
      type: String as () => string,
      default: 'SearchFacilityDetailModal',
    },
    values: {
      type: Object as () => SearchParams,
      default: () => ({}),
    },
  },
  methods: {
    onClose() {
      this.$modal.pop()
      this.$emit('close')
    },
    onSubmit(values: SearchParams) {
      this.$emit('submit', values)
    },
  },
})
